import { Button } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { Table } from '../../../Table';

export const CustomizeMessageModal = styled.div`
  width: 100%;

  ${Table.S.Wrapper} {
    margin-top: 16px;
    max-width: 100%;
    overflow: auto;
  }
`;

export const RevertButton = styled(Button)`
  gap: 8px;
`;

export const ReviewMessageBadgeWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
`;
